import classNames from 'classnames';
import React from 'react';
import { Skeleton } from '@udemy/react-reveal-components';
import styles from "./discovery-units-loading-skeleton.module.css";
export const DiscoveryUnitsLoadingSkeleton = ({
  className
}) => {
  const output = [1, 2].map(el => {
    return /*#__PURE__*/React.createElement("div", {
      className: styles['skeleton-unit'],
      key: el
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.title
    }), /*#__PURE__*/React.createElement("div", {
      className: styles['skeleton-card']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['course-image']
    }), /*#__PURE__*/React.createElement("div", {
      className: styles['info-container']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['course-info']
    }), /*#__PURE__*/React.createElement("div", {
      className: styles['course-info']
    }), /*#__PURE__*/React.createElement("div", {
      className: styles['course-info']
    }), /*#__PURE__*/React.createElement("div", {
      className: styles['course-info']
    }))), /*#__PURE__*/React.createElement("div", {
      className: styles['skeleton-card']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['course-image']
    }), /*#__PURE__*/React.createElement("div", {
      className: styles['info-container']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['course-info']
    }), /*#__PURE__*/React.createElement("div", {
      className: styles['course-info']
    }), /*#__PURE__*/React.createElement("div", {
      className: styles['course-info']
    }), /*#__PURE__*/React.createElement("div", {
      className: styles['course-info']
    }))), /*#__PURE__*/React.createElement("div", {
      className: styles['skeleton-card']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['course-image']
    }), /*#__PURE__*/React.createElement("div", {
      className: styles['info-container']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['course-info']
    }), /*#__PURE__*/React.createElement("div", {
      className: styles['course-info']
    }), /*#__PURE__*/React.createElement("div", {
      className: styles['course-info']
    }), /*#__PURE__*/React.createElement("div", {
      className: styles['course-info']
    }))), /*#__PURE__*/React.createElement("div", {
      className: styles['skeleton-card']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['course-image']
    }), /*#__PURE__*/React.createElement("div", {
      className: styles['info-container']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['course-info']
    }), /*#__PURE__*/React.createElement("div", {
      className: styles['course-info']
    }), /*#__PURE__*/React.createElement("div", {
      className: styles['course-info']
    }), /*#__PURE__*/React.createElement("div", {
      className: styles['course-info']
    }))));
  });
  return /*#__PURE__*/React.createElement(Skeleton, null, /*#__PURE__*/React.createElement("div", {
    "data-testid": "discovery-units-loading-skeleton",
    className: classNames(className, styles['skeleton-units-container'])
  }, output));
};
//# sourceMappingURL=discovery-units-loading-skeleton.react-component.js.map